<template>
  <div>
    <button class="btn-success" @click="add" type="success">Add Case</button>

    <div class="tw-grid tw-grid-cols-12 tw-gap-0 tw-h-10">
      <input
        class="tw-box-border tw-col-start-1 tw-col-end-12 tw-inline-block tw-w-full tw-h-10 tw-px-4 tw-font-normal tw-leading-10 tw-text-gray-600 tw-placeholder-gray-500 tw-transition tw-bg-white tw-border"
        autocomplete="off"
        v-model="filters[0].value"
        placeholder="Search..."
      />
      <div class="search tw-col-start-12 tw-col-end-12 tw-bg-black"></div>
    </div>
    <data-tables
      :filters="filters"
      :data="tableData"
      :table-props="tableProps"
      :pagination-props="paginationProps"
      :page-size="pageSize"
      @row-click="handleRowClick"
      class="data-table"
    >
      <el-table-column prop="member.profile.firstName" label="First Name" width="150">
      </el-table-column>
      <el-table-column prop="member.profile.lastName" label="Last Name" width="150">
      </el-table-column>
      <el-table-column :formatter="typeFormatter" prop="type" label="Type" width="auto">
      </el-table-column>
      <el-table-column prop="status" label="Status" width="auto"> </el-table-column>
      <el-table-column prop="meta.competition.name" label="Competition" width="200">
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        prop="modifiedAt"
        label="Last Modified"
        width="200"
      >
      </el-table-column>
    </data-tables>
  </div>
</template>
<script>
import _ from "lodash";
import { roles, compCasesTypes } from "@/utils/constants";

export default {
  data() {
    return {
      compCasesTypes,
      roles,
      tableData: [],
      pageSize: 20,
      filters: [
        {
          value: "",
          filterFn: (row, filter) =>
            Object.keys(row).some(prop => {
              if (prop === "member") {
                const { firstName, lastName } = row[prop].profile;
                const { _id } = row[prop];
                const filterRegex = new RegExp(filter.value, "i");
                return (
                  _id.toString().match(filterRegex) ||
                  firstName.match(filterRegex) ||
                  lastName.match(filterRegex)
                );
              }
              return false;
            })
        },
        {
          value: []
        }
      ],
      tableProps: {
        border: true
      },
      paginationProps: {
        pageSizes: [20, 50, 100]
      }
    };
  },
  mounted() {
    this.$store.commit("root/loading", true);
    this.$http
      .get("/nrl/api/v1/admin/competition-cases")
      .then(response => {
        this.tableData = _.orderBy(response.data.data, ["createdAt"], ["desc"]);
        this.$store.commit("root/loading", false);
      })
      .catch(() => {
        this.$store.commit("root/loading", false);
        this.$customError();
      });
  },
  methods: {
    add() {
      this.$router.push({ name: "competition-cases.add" });
    },
    handleRowClick(row) {
      this.$router.push({
        name: "competition-cases.view",
        params: {
          id: row._id
        }
      });
    },
    dateFormatter(row) {
      return row.modifiedAt ? this.dayjs(row.modifiedAt).format("MMMM Do YYYY, h:mm:ss a") : "NA";
    },
    typeFormatter(row) {
      return compCasesTypes.find(m => m.type === row.type).name;
    }
  },
  computed: {
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-success {
  @apply tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium  tw-capitalize tw-leading-11px tw-tracking-normal  tw-text-center tw-text-white  tw-bg-green-700  tw-mb-9 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64;
}
.search-bar {
  margin-bottom: 1rem;
}

.data-table {
  width: 100%;
}
.el-pagination {
  margin-top: 1rem !important;
}

.search {
  background-image: url("../../assets/search.svg"); /* Add custom search */
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position-y: 10px;
  padding: 10px;
}
</style>
